// UAT environment — points to the Azure UAT API/SignalR host
export const environment = {
  production: false,
  apiUrl: 'https://meditrack-uat-api.azurewebsites.net/api',
  signalRUrl: 'https://meditrack-uat-api.azurewebsites.net',
  // Cookie mode = the refresh token lives only in the HttpOnly cookie (TC-0061). The AUTH_REFRESH_MODE factory ALSO
  // requires the API hostname to equal the page hostname, so it can never switch on cross-site
  // (azurewebsites.net vs meditrackhealth.in) even if this flag is copied.
  refreshCookieMode: true,
  environment: 'uat'
};
